export default __webpack_public_path__ + "static/media/marathon-compression-logo.294dfe97.webp";